module.exports = __webpack_public_path__ + "static/media/20ECE6.cbb9e8a7.jpg";